<div>
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h5 class="mb-0">
      <i class="bi bi-broadcast me-2"></i>
      Drones
      <span class="badge bg-secondary ms-2">{{ totalDroneCount }}</span>
    </h5>
    <button
      class="btn btn-primary"
      type="button"
      (click)="openAssignDroneModal()"
    >
      <i class="bi bi-plus-circle me-2"></i>
      Assign Drone
    </button>
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    {{ errorMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''" aria-label="Close"></button>
  </div>

  <!-- Success Message -->
  <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
    <i class="bi bi-check-circle-fill me-2"></i>
    {{ successMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="successMessage = ''" aria-label="Close"></button>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="mt-2 text-muted">Loading drones...</div>
  </div>

  <!-- Content when loaded -->
  <div *ngIf="!loading">
    <!-- ADN Assigned Drones Section -->
    <div class="mb-4">
      <h6 class="text-muted mb-3">
        <i class="bi bi-building me-2"></i>
        ADN Leased Drones
        <span class="badge bg-primary ms-2">{{ adnAssignedDrones.length }}</span>
      </h6>

      <div *ngIf="adnAssignedDrones.length > 0">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Serial #</th>
              <th>Name</th>
              <th>N-Number</th>
              <th>Status</th>
              <th>Assigned</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let drone of adnAssignedDrones">
              <td>
                <code>{{ drone.serialNumber }}</code>
              </td>
              <td>
                <div class="text-truncate" style="max-width: 200px;">
                  {{ drone.name || drone.modelName || 'N/A' }}
                </div>
              </td>
              <td>
                <code *ngIf="drone.nNumber">{{ drone.nNumber }}</code>
                <span *ngIf="!drone.nNumber" class="text-muted">-</span>
              </td>
              <td>
                <span class="badge" [ngClass]="getDroneStatusBadgeClass(drone.status)">
                  {{ getDroneStatusLabel(drone.status) }}
                </span>
              </td>
              <td>{{ drone.assignedAt ? formatAssignedDate(drone.assignedAt) : 'N/A' }}</td>
              <td class="text-end">
                <div class="dropdown">
                  <button
                    class="btn btn-sm btn-outline-secondary dropdown-toggle"
                    type="button"
                    [id]="'adnDroneActions-' + drone.id"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end" [attr.aria-labelledby]="'adnDroneActions-' + drone.id">
                    <li>
                      <a class="dropdown-item" href="#" (click)="viewDroneDetails(drone.id); $event.preventDefault()">
                        <i class="bi bi-eye me-2"></i>
                        View Details
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#" (click)="viewMaintenanceHistory(drone.id); $event.preventDefault()">
                        <i class="bi bi-tools me-2"></i>
                        Maintenance History
                      </a>
                    </li>
                    <li><hr class="dropdown-divider" /></li>
                    <li>
                      <a class="dropdown-item text-danger" href="#" (click)="showUnassignedModal(drone); $event.preventDefault()">
                        <i class="bi bi-x-circle me-2"></i>
                        Unassign
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="adnAssignedDrones.length === 0" class="text-center py-4 rounded bg-body-tertiary border">
        <i class="bi bi-building text-muted d-block mb-2"></i>
        <p class="text-muted mb-0">No ADN drones assigned to this organization.</p>
      </div>
    </div>

    <!-- Organization Owned Drones Section -->
    <div class="mb-4">
      <h6 class="text-muted mb-3">
        <i class="bi bi-person-badge me-2"></i>
        Organization Owned Drones
        <span class="badge bg-info ms-2">{{ organizationOwnedDrones.length }}</span>
      </h6>

      <div *ngIf="organizationOwnedDrones.length > 0" class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Serial #</th>
              <th>Name</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>N-Number</th>
              <th>Status</th>
              <th>Added</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let drone of organizationOwnedDrones">
              <td>
                <code>{{ drone.serialNumber }}</code>
              </td>
              <td>
                <div class="text-truncate" style="max-width: 150px;">
                  {{ drone.name || 'N/A' }}
                </div>
              </td>
              <td>{{ drone.manufacturerName || 'N/A' }}</td>
              <td>{{ drone.modelName || 'N/A' }}</td>
              <td>
                <code *ngIf="drone.nNumber">{{ drone.nNumber }}</code>
                <span *ngIf="!drone.nNumber" class="text-muted">-</span>
              </td>
              <td>
                <span class="badge" [ngClass]="getOrgDroneStatusBadgeClass(drone.status)">
                  {{ getOrgDroneStatusLabel(drone.status) }}
                </span>
              </td>
              <td>{{ drone.createdAt ? formatAssignedDate(drone.createdAt) : 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="organizationOwnedDrones.length === 0" class="text-center py-4 rounded bg-body-tertiary border">
        <i class="bi bi-person-badge text-muted d-block mb-2"></i>
        <p class="text-muted mb-0">This organization hasn't added any of their own drones.</p>
      </div>
    </div>

    <!-- Empty State - No Drones at All -->
    <div *ngIf="totalDroneCount === 0" class="text-center py-5">
      <i class="bi bi-broadcast display-4 text-muted d-block mb-3"></i>
      <h6 class="text-muted mb-3">No drones</h6>
      <p class="text-muted">This organization doesn't have any drones (ADN-leased or owned).</p>
      <button class="btn btn-primary" (click)="openAssignDroneModal()">
        <i class="bi bi-plus-circle me-2"></i>
        Assign First ADN Drone
      </button>
    </div>
  </div>

  <!-- Assign Drone Modal -->
  <app-assign-drone-modal
    *ngIf="showAssignModal"
    [organizationId]="organizationId"
    [organizationName]="organizationName"
    (droneAssigned)="onDroneAssigned()"
    (closed)="closeAssignModal()"
  ></app-assign-drone-modal>

  @if (showUnassignModal) {
    <app-confirmation-modal-with-reason
      title="Unassign Drone"
      message="Why are you unassigning this drone?"
      confirmLabel="Unassign"
      variant="danger"
      reasonLabel="Reason"
      reasonPlaceholder="e.g., Customer returned for maintenance"
      [processing]="processingUnassign"
      (confirmed)="unassignDrone($event)"
      (cancelled)="closeUnassignModal()">
    </app-confirmation-modal-with-reason>
  }

</div>
